// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ICardDto,
  ICardPurseAccessUpdateDto,
  ICardPurseAccountDto,
  ICardReplaceDto,
  ICardShipmentEventsDto,
  ICardStatusDto,
  ICardVerifyDto,
  IErrorDto,
  IGenericErrorDto,
  ILockReasonTypeDto,
  IPageCardActivityDto,
} from '../models/index';
import {
    ICardDtoFromJSON,
    ICardDtoToJSON,
    ICardPurseAccessUpdateDtoFromJSON,
    ICardPurseAccessUpdateDtoToJSON,
    ICardPurseAccountDtoFromJSON,
    ICardPurseAccountDtoToJSON,
    ICardReplaceDtoFromJSON,
    ICardReplaceDtoToJSON,
    ICardShipmentEventsDtoFromJSON,
    ICardShipmentEventsDtoToJSON,
    ICardStatusDtoFromJSON,
    ICardStatusDtoToJSON,
    ICardVerifyDtoFromJSON,
    ICardVerifyDtoToJSON,
    IErrorDtoFromJSON,
    IErrorDtoToJSON,
    IGenericErrorDtoFromJSON,
    IGenericErrorDtoToJSON,
    ILockReasonTypeDtoFromJSON,
    ILockReasonTypeDtoToJSON,
    IPageCardActivityDtoFromJSON,
    IPageCardActivityDtoToJSON,
} from '../models/index';

export interface ConfirmFraudStatusRequest {
    cardId: number;
}

export interface GetCardActivitiesRequest {
    cardId: number;
    employeeId?: number;
    cardAccountId?: number;
    name?: string;
    statuses?: Set<string>;
    categories?: Set<string>;
    startDate?: Date;
    endDate?: Date;
    page?: number;
    size?: number;
    sort?: Array<string>;
}

export interface GetCardShipmentEventsRequest {
    cardId: number;
}

export interface ReplaceCardRequest {
    cardId: number;
    iCardReplaceDto: ICardReplaceDto;
}

export interface SendPushProvisioningNotificationRequest {
    cardId: number;
}

export interface UpdateCardAsVerifiedRequest {
    cardId: number;
}

export interface UpdateCardPursesAccessRequest {
    iCardPurseAccessUpdateDto: ICardPurseAccessUpdateDto;
}

export interface UpdateCardStatusRequest {
    cardId: number;
    iCardStatusDto: ICardStatusDto;
}

export interface VerifyLast4Request {
    iCardVerifyDto: ICardVerifyDto;
}

/**
 * CardServiceServiceApi - interface
 * 
 * @export
 * @interface CardServiceServiceApiInterface
 */
export interface CardServiceServiceApiInterface {
    /**
     * 
     * @summary Confirm card fraud status
     * @param {number} cardId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardServiceServiceApiInterface
     */
    confirmFraudStatusRaw(requestParameters: ConfirmFraudStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Confirm card fraud status
     */
    confirmFraudStatus(requestParameters: ConfirmFraudStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get card activities
     * @param {number} cardId Employee\&#39;s card id
     * @param {number} [employeeId] For admin purpose. The default is fetched from the token
     * @param {number} [cardAccountId] Employee\&#39;s card account id
     * @param {string} [name] 
     * @param {Set<string>} [statuses] Status for BankingActivity - \&quot;Pending\&quot;, \&quot;Completed\&quot;  Status for ClaimActivity - PROCESSING, NEEDS_HELP, PAID, PARTIALLY_PAID, WAITING_FOR_FUNDS, PENDING, REPAID, DENIED,DECLINED, REPROCESSING, PARTIALLY_REPAID, REPAYMENT_REQUIRED, CANCELED 
     * @param {Set<string>} [categories] Claim category types
     * @param {Date} [startDate] Start Date in ISO format. Example: 2022-12-01
     * @param {Date} [endDate] End Date in ISO format. Example: 2022-12-31
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardServiceServiceApiInterface
     */
    getCardActivitiesRaw(requestParameters: GetCardActivitiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPageCardActivityDto>>;

    /**
     * Get card activities
     */
    getCardActivities(requestParameters: GetCardActivitiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPageCardActivityDto>;

    /**
     * 
     * @summary Get card shipment events
     * @param {number} cardId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardServiceServiceApiInterface
     */
    getCardShipmentEventsRaw(requestParameters: GetCardShipmentEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICardShipmentEventsDto>>;

    /**
     * Get card shipment events
     */
    getCardShipmentEvents(requestParameters: GetCardShipmentEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICardShipmentEventsDto>;

    /**
     * 
     * @summary Get all existing lock reasons
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardServiceServiceApiInterface
     */
    getLockReasonsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ILockReasonTypeDto>>>;

    /**
     * Get all existing lock reasons
     */
    getLockReasons(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ILockReasonTypeDto>>;

    /**
     * 
     * @summary Replace card
     * @param {number} cardId 
     * @param {ICardReplaceDto} iCardReplaceDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardServiceServiceApiInterface
     */
    replaceCardRaw(requestParameters: ReplaceCardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICardDto>>;

    /**
     * Replace card
     */
    replaceCard(requestParameters: ReplaceCardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICardDto>;

    /**
     * 
     * @summary Publish Push Provisioning Notification
     * @param {number} cardId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardServiceServiceApiInterface
     */
    sendPushProvisioningNotificationRaw(requestParameters: SendPushProvisioningNotificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Publish Push Provisioning Notification
     */
    sendPushProvisioningNotification(requestParameters: SendPushProvisioningNotificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {number} cardId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardServiceServiceApiInterface
     */
    updateCardAsVerifiedRaw(requestParameters: UpdateCardAsVerifiedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    updateCardAsVerified(requestParameters: UpdateCardAsVerifiedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Lock or unlock specific card purses
     * @param {ICardPurseAccessUpdateDto} iCardPurseAccessUpdateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardServiceServiceApiInterface
     */
    updateCardPursesAccessRaw(requestParameters: UpdateCardPursesAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ICardPurseAccountDto>>>;

    /**
     * Lock or unlock specific card purses
     */
    updateCardPursesAccess(requestParameters: UpdateCardPursesAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ICardPurseAccountDto>>;

    /**
     * 
     * @summary Update card status
     * @param {number} cardId 
     * @param {ICardStatusDto} iCardStatusDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardServiceServiceApiInterface
     */
    updateCardStatusRaw(requestParameters: UpdateCardStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICardDto>>;

    /**
     * Update card status
     */
    updateCardStatus(requestParameters: UpdateCardStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICardDto>;

    /**
     * 
     * @param {ICardVerifyDto} iCardVerifyDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CardServiceServiceApiInterface
     */
    verifyLast4Raw(requestParameters: VerifyLast4Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    verifyLast4(requestParameters: VerifyLast4Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class CardServiceServiceApi extends runtime.BaseAPI implements CardServiceServiceApiInterface {

    /**
     * Confirm card fraud status
     */
    async confirmFraudStatusRaw(requestParameters: ConfirmFraudStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['cardId'] == null) {
            throw new runtime.RequiredError(
                'cardId',
                'Required parameter "cardId" was null or undefined when calling confirmFraudStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/cards/{card-id}/fraud-confirmation`;
        urlPath = urlPath.replace(`{${"card-id"}}`, encodeURIComponent(String(requestParameters['cardId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Confirm card fraud status
     */
    async confirmFraudStatus(requestParameters: ConfirmFraudStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.confirmFraudStatusRaw(requestParameters, initOverrides);
    }

    /**
     * Get card activities
     */
    async getCardActivitiesRaw(requestParameters: GetCardActivitiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IPageCardActivityDto>> {
        if (requestParameters['cardId'] == null) {
            throw new runtime.RequiredError(
                'cardId',
                'Required parameter "cardId" was null or undefined when calling getCardActivities().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['employeeId'] != null) {
            queryParameters['employee_id'] = requestParameters['employeeId'];
        }

        if (requestParameters['cardId'] != null) {
            queryParameters['card_id'] = requestParameters['cardId'];
        }

        if (requestParameters['cardAccountId'] != null) {
            queryParameters['card_account_id'] = requestParameters['cardAccountId'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['statuses'] != null) {
            queryParameters['statuses'] = requestParameters['statuses'];
        }

        if (requestParameters['categories'] != null) {
            queryParameters['categories'] = requestParameters['categories'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['start_date'] = (requestParameters['startDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['end_date'] = (requestParameters['endDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/activities/cards`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IPageCardActivityDtoFromJSON(jsonValue));
    }

    /**
     * Get card activities
     */
    async getCardActivities(requestParameters: GetCardActivitiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IPageCardActivityDto> {
        const response = await this.getCardActivitiesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get card shipment events
     */
    async getCardShipmentEventsRaw(requestParameters: GetCardShipmentEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICardShipmentEventsDto>> {
        if (requestParameters['cardId'] == null) {
            throw new runtime.RequiredError(
                'cardId',
                'Required parameter "cardId" was null or undefined when calling getCardShipmentEvents().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/cards/{card-id}/shipment-events`;
        urlPath = urlPath.replace(`{${"card-id"}}`, encodeURIComponent(String(requestParameters['cardId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ICardShipmentEventsDtoFromJSON(jsonValue));
    }

    /**
     * Get card shipment events
     */
    async getCardShipmentEvents(requestParameters: GetCardShipmentEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICardShipmentEventsDto> {
        const response = await this.getCardShipmentEventsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all existing lock reasons
     */
    async getLockReasonsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ILockReasonTypeDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/enums/lock-reasons`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ILockReasonTypeDtoFromJSON));
    }

    /**
     * Get all existing lock reasons
     */
    async getLockReasons(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ILockReasonTypeDto>> {
        const response = await this.getLockReasonsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Replace card
     */
    async replaceCardRaw(requestParameters: ReplaceCardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICardDto>> {
        if (requestParameters['cardId'] == null) {
            throw new runtime.RequiredError(
                'cardId',
                'Required parameter "cardId" was null or undefined when calling replaceCard().'
            );
        }

        if (requestParameters['iCardReplaceDto'] == null) {
            throw new runtime.RequiredError(
                'iCardReplaceDto',
                'Required parameter "iCardReplaceDto" was null or undefined when calling replaceCard().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/cards/{card-id}/replacement`;
        urlPath = urlPath.replace(`{${"card-id"}}`, encodeURIComponent(String(requestParameters['cardId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ICardReplaceDtoToJSON(requestParameters['iCardReplaceDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ICardDtoFromJSON(jsonValue));
    }

    /**
     * Replace card
     */
    async replaceCard(requestParameters: ReplaceCardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICardDto> {
        const response = await this.replaceCardRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Publish Push Provisioning Notification
     */
    async sendPushProvisioningNotificationRaw(requestParameters: SendPushProvisioningNotificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['cardId'] == null) {
            throw new runtime.RequiredError(
                'cardId',
                'Required parameter "cardId" was null or undefined when calling sendPushProvisioningNotification().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/cards/{card-id}/provision-notification`;
        urlPath = urlPath.replace(`{${"card-id"}}`, encodeURIComponent(String(requestParameters['cardId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Publish Push Provisioning Notification
     */
    async sendPushProvisioningNotification(requestParameters: SendPushProvisioningNotificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.sendPushProvisioningNotificationRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateCardAsVerifiedRaw(requestParameters: UpdateCardAsVerifiedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['cardId'] == null) {
            throw new runtime.RequiredError(
                'cardId',
                'Required parameter "cardId" was null or undefined when calling updateCardAsVerified().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/cards/{card-id}/verification`;
        urlPath = urlPath.replace(`{${"card-id"}}`, encodeURIComponent(String(requestParameters['cardId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateCardAsVerified(requestParameters: UpdateCardAsVerifiedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateCardAsVerifiedRaw(requestParameters, initOverrides);
    }

    /**
     * Lock or unlock specific card purses
     */
    async updateCardPursesAccessRaw(requestParameters: UpdateCardPursesAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ICardPurseAccountDto>>> {
        if (requestParameters['iCardPurseAccessUpdateDto'] == null) {
            throw new runtime.RequiredError(
                'iCardPurseAccessUpdateDto',
                'Required parameter "iCardPurseAccessUpdateDto" was null or undefined when calling updateCardPursesAccess().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/card-purses`;

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ICardPurseAccessUpdateDtoToJSON(requestParameters['iCardPurseAccessUpdateDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ICardPurseAccountDtoFromJSON));
    }

    /**
     * Lock or unlock specific card purses
     */
    async updateCardPursesAccess(requestParameters: UpdateCardPursesAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ICardPurseAccountDto>> {
        const response = await this.updateCardPursesAccessRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update card status
     */
    async updateCardStatusRaw(requestParameters: UpdateCardStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ICardDto>> {
        if (requestParameters['cardId'] == null) {
            throw new runtime.RequiredError(
                'cardId',
                'Required parameter "cardId" was null or undefined when calling updateCardStatus().'
            );
        }

        if (requestParameters['iCardStatusDto'] == null) {
            throw new runtime.RequiredError(
                'iCardStatusDto',
                'Required parameter "iCardStatusDto" was null or undefined when calling updateCardStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/cards/{card-id}`;
        urlPath = urlPath.replace(`{${"card-id"}}`, encodeURIComponent(String(requestParameters['cardId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ICardStatusDtoToJSON(requestParameters['iCardStatusDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ICardDtoFromJSON(jsonValue));
    }

    /**
     * Update card status
     */
    async updateCardStatus(requestParameters: UpdateCardStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ICardDto> {
        const response = await this.updateCardStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async verifyLast4Raw(requestParameters: VerifyLast4Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['iCardVerifyDto'] == null) {
            throw new runtime.RequiredError(
                'iCardVerifyDto',
                'Required parameter "iCardVerifyDto" was null or undefined when calling verifyLast4().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/cards/verify-last-4`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ICardVerifyDtoToJSON(requestParameters['iCardVerifyDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async verifyLast4(requestParameters: VerifyLast4Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.verifyLast4Raw(requestParameters, initOverrides);
    }

}
